// extracted by mini-css-extract-plugin
export default {"noKnowledgebases":"noKnowledgebases___zeGJnpDJBTs"};